function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
/**
 * Vault rental READ primitives.
 *
 * Existing Vault READ / DATA REQUEST architecture:
 *   client: Vault.sendAccessFileRequest(vault_data, access_script_override, cb)
 *        → network.sendRequestAsTransaction('vault access file', data, …)
 *   server: Vault.handlePeerTransaction for request === 'vault access file'
 *        → scripting.evaluateWithTransaction(access_script, tx)
 *        → Archive loadTransactions({ owner: access_hash, …, sig: file_id })
 *
 * Rental reads use the same peer request and validation. The rental locking
 * script (file_access_script on vault-nft-rental / store-nft-rental) is
 * supplied as access_script_override; Archive owner remains the script hash
 * set at vault add file time.
 */

var Transaction = require('../../../../lib/saito/transaction')["default"];

/**
 * Build vault_data for sendAccessFileRequest from a rental NFT (or explicit
 * fields). Requires current wallet slip utxokeys — sendAccessFileRequest
 * still validates them even when a full rental script is provided.
 *
 * @param {object} nft SaitoNFT carrying txmsg.data Vault fields
 * @returns {object} vault_data
 */
function vaultDataFromRentalNft(nft) {
  var _nft$tx, _nft$tx$returnMessage, _nft$slip, _nft$slip2, _nft$slip3, _nft$slip4, _nft$slip5, _nft$slip6;
  if (!nft) {
    throw new Error('Vault rental read requires an NFT');
  }
  var data = ((_nft$tx = nft.tx) === null || _nft$tx === void 0 || (_nft$tx$returnMessage = _nft$tx.returnMessage) === null || _nft$tx$returnMessage === void 0 || (_nft$tx$returnMessage = _nft$tx$returnMessage.call(_nft$tx)) === null || _nft$tx$returnMessage === void 0 ? void 0 : _nft$tx$returnMessage.data) || nft.data || {};
  var file_id = data.file_id ? String(data.file_id) : '';
  if (!file_id) {
    throw new Error('Vault rental read requires file_id on the NFT');
  }
  return {
    nft_id: nft.id || '',
    file_id: file_id,
    filename: data.filename || '',
    link: data.link || '',
    nft_type: data.nft_type || (typeof nft.returnType === 'function' ? nft.returnType() : ''),
    file_access_script: data.file_access_script || null,
    slip1_utxokey: ((_nft$slip = nft.slip1) === null || _nft$slip === void 0 ? void 0 : _nft$slip.utxo_key) || ((_nft$slip2 = nft.slip1) === null || _nft$slip2 === void 0 ? void 0 : _nft$slip2.utxoKey) || '',
    slip2_utxokey: ((_nft$slip3 = nft.slip2) === null || _nft$slip3 === void 0 ? void 0 : _nft$slip3.utxo_key) || ((_nft$slip4 = nft.slip2) === null || _nft$slip4 === void 0 ? void 0 : _nft$slip4.utxoKey) || '',
    slip3_utxokey: ((_nft$slip5 = nft.slip3) === null || _nft$slip5 === void 0 ? void 0 : _nft$slip5.utxo_key) || ((_nft$slip6 = nft.slip3) === null || _nft$slip6 === void 0 ? void 0 : _nft$slip6.utxoKey) || ''
  };
}

/**
 * Request the protected file from Vault using rental authorization.
 *
 * Delegates entirely to Vault.sendAccessFileRequest. Does not create a new
 * peer-request type. Signing of the off-chain request transaction is performed
 * inside sendRequestAsTransaction / wallet paths used by sendAccessFileRequest.
 *
 * Script validation occurs on the Vault server in handlePeerTransaction
 * (evaluateWithTransaction). Archive interaction occurs there via
 * storage.loadTransactions.
 *
 * @param {object} app
 * @param {object} mod Vault module instance
 * @param {object} opts
 * @param {object} [opts.nft] store-nft-rental / vault-nft-rental SaitoNFT
 * @param {object} [opts.vault_data] explicit vault_data (overrides nft)
 * @param {string|object} [opts.access_script] witnessed rental script;
 *   defaults to vault_data.file_access_script / nft data
 * @param {function} [opts.callback] receives base64 file bytes or null
 * @returns {Promise<*>} result of sendAccessFileRequest (often null; async via callback)
 */
function createRentalReadTransaction(_x, _x2) {
  return _createRentalReadTransaction.apply(this, arguments);
}
/**
 * Process a successful Vault access-file response on the client.
 *
 * Server-side receive/validation remains Vault.handlePeerTransaction for
 * 'vault access file' (unchanged). This adapter mirrors the file-extraction
 * portion of sendAccessFileRequest's callback so rental callers can reuse it
 * without depending on the download UI.
 *
 * @param {object} app
 * @param {object} mod Vault module instance
 * @param {object} opts
 * @param {object|array} opts.response peer callback payload ({ status, txs } or txs[])
 * @param {boolean} [opts.download=false] trigger browser download when true
 * @returns {{ ok: boolean, files: Array<{ filename: string, mime: string, base64: string }>, error?: string }}
 */
function _createRentalReadTransaction() {
  _createRentalReadTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, mod) {
    var opts,
      vault_data,
      access_script,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          opts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          if (!(!app || !mod)) {
            _context.n = 1;
            break;
          }
          throw new Error('Vault rental read requires app and Vault module');
        case 1:
          if (!(typeof mod.sendAccessFileRequest !== 'function')) {
            _context.n = 2;
            break;
          }
          throw new Error('Vault.sendAccessFileRequest is unavailable');
        case 2:
          vault_data = opts.vault_data || null;
          if (!vault_data) {
            vault_data = vaultDataFromRentalNft(opts.nft);
          }
          if (vault_data.file_id) {
            _context.n = 3;
            break;
          }
          throw new Error('Vault rental read requires file_id');
        case 3:
          if (!(!vault_data.nft_id || !vault_data.slip1_utxokey || !vault_data.slip2_utxokey || !vault_data.slip3_utxokey)) {
            _context.n = 4;
            break;
          }
          throw new Error('Vault rental read requires nft_id and slip utxokeys (sendAccessFileRequest invariant)');
        case 4:
          access_script = opts.access_script != null ? opts.access_script : vault_data.file_access_script;
          if (access_script) {
            _context.n = 5;
            break;
          }
          throw new Error('Vault rental read requires file_access_script / access_script');
        case 5:
          return _context.a(2, mod.sendAccessFileRequest(vault_data, access_script, opts.callback || null));
      }
    }, _callee);
  }));
  return _createRentalReadTransaction.apply(this, arguments);
}
function receiveRentalReadTransaction(app, mod) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var res = opts.response;
  if (!res) {
    return {
      ok: false,
      files: [],
      error: 'empty_response'
    };
  }
  if (res.status === 'err') {
    return {
      ok: false,
      files: [],
      error: res.err || 'access_denied'
    };
  }
  var txs = [];
  if (Array.isArray(res.txs)) {
    txs = res.txs;
  } else if (Array.isArray(res)) {
    txs = res;
  }
  if (!txs.length) {
    return {
      ok: false,
      files: [],
      error: 'no_transactions'
    };
  }
  var files = [];
  for (var i = 0; i < txs.length; i++) {
    try {
      var _txmsg$data, _txmsg$data2;
      var tx = new Transaction();
      tx.deserialize_from_web(app, txs[i]);
      var txmsg = tx.returnMessage() || {};
      var filename = ((_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.name) || 'vault.bin';
      var file = String(((_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.file) || '');
      if (!file) {
        continue;
      }
      var parts = file.split(',');
      var header = parts[0] || '';
      var base64Data = parts[1] || '';
      var mimeMatch = header.match(/data:(.*);base64/);
      var mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
      files.push({
        filename: filename,
        mime: mime,
        base64: base64Data
      });
      if (opts.download && typeof document !== 'undefined') {
        var binary = atob(base64Data);
        var bytes = new Uint8Array(binary.length);
        for (var j = 0; j < binary.length; j++) {
          bytes[j] = binary.charCodeAt(j);
        }
        var blob = new Blob([bytes], {
          type: mime
        });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.log('VAULT: rental read response parse error:', (err === null || err === void 0 ? void 0 : err.message) || err);
    }
  }
  if (!files.length) {
    return {
      ok: false,
      files: [],
      error: 'parse_failed'
    };
  }
  return {
    ok: true,
    files: files
  };
}
module.exports = {
  createRentalReadTransaction: createRentalReadTransaction,
  receiveRentalReadTransaction: receiveRentalReadTransaction,
  vaultDataFromRentalNft: vaultDataFromRentalNft
};